import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

import localization from '@progressivebeef/shared/src/localization/i18n';
import { getLocale } from '@progressivebeef/shared/src/services/storageService/GlobalData';
import AssetConstants from '@progressivebeef/shared/src/constants/AssetConstants';
import { ERROR_SCREEN_TYPES } from '@progressivebeef/shared/src/constants/AppConstants';

const getPlaceholderContent = (screenType) => {
  const locale = localization[getLocale()];

  switch (screenType) {
    case ERROR_SCREEN_TYPES.NO_RECORDS:
      return {
        title: locale.NO_RECORDS,
        message: locale.NO_RECORD_MESSAGE,
        buttonText: null,
        image: AssetConstants.recordNoRecordFound,
      };
    case ERROR_SCREEN_TYPES.NETWORK_ERROR:
      return {
        title: locale.RECORD_NO_INTERNET_TITLE,
        message: locale.RECORD_NO_INTERNET_MESSAGE,
        buttonText: locale.RETRY,
        image: AssetConstants.recordNoInternet,
      };
    case ERROR_SCREEN_TYPES.SERVER_ERROR:
      return {
        title: '',
        message: locale.RECORD_SERVER_ERROR_MESSAGE,
        buttonText: locale.REFRESH_PAGE,
        image: AssetConstants.recordServerError,
      };
    default:
      return {
        title: locale.NO_RECORDS,
        message: locale.NO_RECORD_MESSAGE,
        buttonText: null,
        image: AssetConstants.recordNoRecordFound,
      };
  }
};

const NoRecordsFound = ({
  screenType = ERROR_SCREEN_TYPES.NO_RECORDS,
  image,
  title,
  message,
  buttonText,
  onButtonPress,
}) => {
  const placeholderContent = getPlaceholderContent(screenType);

  const contentTitle = title ?? placeholderContent.title;
  const contentMessage = message ?? placeholderContent.message;
  const contentButtonText = buttonText ?? placeholderContent.buttonText;
  const contentImage = image ?? placeholderContent.image;

  return (
    <div className="record-binder-placeholder">
      {contentImage && (
        <div className="record-binder-placeholder__image">
          <img
            src={contentImage}
            alt=""
            className="record-binder-placeholder__img"
          />
        </div>
      )}
      {contentTitle && (
        <h2 className="record-binder-placeholder__title">{contentTitle}</h2>
      )}
      {contentMessage && (
        <p className="record-binder-placeholder__message">{contentMessage}</p>
      )}
      {contentButtonText && onButtonPress && (
        <button
          type="button"
          className="record-binder-placeholder__button"
          onClick={onButtonPress}
        >
          {contentButtonText}
        </button>
      )}
    </div>
  );
};

NoRecordsFound.propTypes = {
  screenType: PropTypes.oneOf([
    ERROR_SCREEN_TYPES.NO_RECORDS,
    ERROR_SCREEN_TYPES.NETWORK_ERROR,
    ERROR_SCREEN_TYPES.SERVER_ERROR,
  ]),
  image: PropTypes.string,
  title: PropTypes.string,
  message: PropTypes.string,
  buttonText: PropTypes.string,
  onButtonPress: PropTypes.func,
};

NoRecordsFound.defaultProps = {
  screenType: ERROR_SCREEN_TYPES.NO_RECORDS,
  image: undefined,
  title: undefined,
  message: undefined,
  buttonText: undefined,
  onButtonPress: undefined,
};

export default NoRecordsFound;
